import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import { BASE_URL } from "../../constant/api";
import AuthBackground from "../../components/Home/AuthBackground/AuthBackground ";
import img from "../../assets/users/logo.png";
import { info } from "autoprefixer";
/* ---------- helper ---------- */
const detectType = (value) => {
  if (/^\d{10}$/.test(value)) return "mobile";
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "email";
  return "";
};

function LoginOTP() {
  const {
    requestOTP,
    verifyOTP,
    login,
    isAuthenticated,
    setUser,
    setIsAuthenticated,
  } = useAuth();
  const location = useLocation();
  const from = location.state?.from || "/";
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds

  // Toggle between login methods: "otp" or "password"
  const [loginMethod, setLoginMethod] = useState("otp");

  // "step" controls which form is shown for OTP flow: "request", "verify", or "name"
  const [step, setStep] = useState("request");

  // Form state for email, OTP digits, and first name.
  const [email, setEmail] = useState("");
  const [first_name, setFirst_name] = useState("");
  // otpDigits is an array of 6 strings, one for each OTP digit.
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));

  // Form state for password login
  // const [formData, setFormData] = useState({
  //   username: "",
  //   password: "",
  // });

   const [formData, setFormData] = useState({
      identifier: "",
      password: "",
      type: "",
      for: "customer",
    });

  // UI states
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  // Store the OTP verification response for later use (e.g., when registering the name)
  const [verifyResponse, setVerifyResponse] = useState(null);

  // Create refs for each OTP input for easier focus management.
  const otpRefs = useRef([]);

  //   for timmer

  useEffect(() => {
    let countdownInterval;
    let expiryTimeout;

    if (step === "verify") {
      setTimeLeft(300); // reset timer

      countdownInterval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      expiryTimeout = setTimeout(() => {
        setStep("request");
        setOtpDigits(Array(6).fill(""));
        setSuccessMessage(null);
        setError(null);
      }, 300000); // 5 minutes
    }

    return () => {
      clearInterval(countdownInterval);
      clearTimeout(expiryTimeout);
    };
  }, [step]);
  // Toggle between login methods
  const handleToggleMethod = (method) => {
    setLoginMethod(method);
    setError(null);
    setSuccessMessage(null);
    // Reset OTP step when switching methods
    if (method === "otp") {
      setStep("request");
    }
  };

  // Handle the OTP request form submission
  const handleRequestSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    if (!formData.identifier) {
      setError("Please enter your email or mobile number.");
      return;
    }

    setIsLoading(true);
    const result = await requestOTP({identifier: formData.identifier, type: detectType(formData.identifier), for: "customer"});
    setIsLoading(false);

    if (result.success) {
      setSuccessMessage(
        result.message || "OTP sent successfully. Please check your email.",
      );
      // Move to the verify step.
      setStep("verify");
    } else {
      setError(result.message);
    }
  };

  // Handle change for each OTP input box.
  const handleOtpChange = (index, value) => {
    // Ensure only one digit is entered.
    if (value.length > 1) {
      value = value.slice(-1);
    }
    const newOtpDigits = [...otpDigits];
    newOtpDigits[index] = value;
    setOtpDigits(newOtpDigits);

    // Automatically focus the next input if the current input has a value.
    if (value && index < otpDigits.length - 1) {
      otpRefs.current[index + 1].focus();
    }
  };

  // Handle keyDown events for OTP input boxes (to manage backspace navigation).
  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && otpDigits[index] === "" && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  // Handle paste event to allow pasting a complete OTP.
  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    // Only process if the pasted data is numeric.
    if (/^\d+$/.test(pasteData)) {
      const digits = pasteData.split("").slice(0, otpDigits.length);
      // Create a new array with pasted digits and fill missing entries with empty strings.
      const newOtpDigits = Array(otpDigits.length)
        .fill("")
        .map((_, i) => digits[i] || "");
      setOtpDigits(newOtpDigits);
      // Focus the last input if paste fills all fields.
      if (digits.length >= otpDigits.length) {
        otpRefs.current[otpDigits.length - 1].focus();
      } else {
        otpRefs.current[digits.length].focus();
      }
    }
  };

  // Handle the OTP verification form submission
  const handleVerifySubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    // Combine the OTP digits into a single string.
    const otp = otpDigits.join("");
    if (otp.length < 6) {
      setError("Please enter the complete 6-digit OTP.");
      return;
    }

    setIsLoading(true);
    const result = await verifyOTP({identifier: formData.identifier, otp, type: detectType(formData.identifier)});
    setIsLoading(false);
    console.log("verify otp",result);

    // if (result.success) {
    //   setAccessToken(result.response.access);
    //   // Store the verifyOTP response so we can use its values later.
    //   setVerifyResponse(result.response);
    //   if (
    //     !result.response.first_name ||
    //     result.response.first_name.trim() === ""
    //   ) {
    //     // If the user's first name is missing, move to the "name" step.
    //     setStep("name");
    //   } else {
    //     // User already has a name: complete the login.
    //     const userData = {
    //       email: result.response.email,
    //       user_name: result.response.user_name,
    //       user_type: result.response.user_type,
    //     };
    //     // Store tokens and user data.
    //     localStorage.setItem("user", JSON.stringify(userData));
    //     localStorage.setItem("token", result.response.access);
    //     localStorage.setItem("refresh", result.response.refresh);
    //     setUser(userData);
    //     setIsAuthenticated(true);
    //     navigate(from);
    //   }
    // } else {
    //   setError(result.message);
    // }

    if (result.success) {
  // store access token for firstname API
  setAccessToken(result.auth.access);

  // store full verify result for later use
  setVerifyResponse(result);

  if (result.needProfile) {
    // backend already told profile is incomplete
    
    setStep("name");
  } else {
    // profile already complete → login
    const userData = {
      email: result.profile.email,
      user_name: result.profile.userName,
      user_type: result.auth.userType,
    };

      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("token", result.auth.access);
      localStorage.setItem("refresh", result.auth.refresh);

      setUser(userData);
    setIsAuthenticated(true);
    navigate(from);
  }
} else {
  setError(result.message);
}

  };

  // Handle the first_name submission form when the user needs to register a first name.
  const handleNameSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    if (!first_name) {
      setError("Please enter your name.");
      return;
    }

    setIsLoading(true);
    try {
      const nameResponse = await axios.post(
        `${BASE_URL}/accounts/firstname/create/`,
        { first_name },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${accessToken}`,
          },
        },
      );
      setIsLoading(false);
      // After successful name registration, update the stored verifyOTP response with the new first_name.
      console.log("nameResponse", nameResponse);
      console.log("verifyResponse before update", verifyResponse);
      const updatedResponse = { ...verifyResponse };
      const userData = {
        email: updatedResponse.profile.email,
        user_name: updatedResponse.profile.user_name,
        user_type: updatedResponse.auth.userType,
      };
      // Store tokens and user data.
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("token", updatedResponse.auth.access);
      localStorage.setItem("refresh", updatedResponse.auth.refresh);
      setUser(userData);
      setIsAuthenticated(true);
      navigate(from);
    } catch (err) {
      setIsLoading(false);
      console.error("Error during name registration:", err);
      setError("An error occurred while registering your name.");
    }
  };

  // Handle change for password login form fields
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle the password login form submission
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    setSuccessMessage(null);
    setError(null);

    if (!formData.identifier || !formData.password) {
      setError("Please fill in both fields.");
      setIsLoading(false);
      return;
    }

    try {
      const success = await login(formData);
      if (success.success) {
        setSuccessMessage("Login Successful!");
      } else {
        setError("Invalid username or password");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setError("Invalid username or password.");
      } else {
        setError("An error occurred. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Redirect if already authenticated.
  if (isAuthenticated) {
    return <Navigate to={from} />;
  }

  return (
    <div className="grid h-screen w-screen grid-cols-1 md:grid-cols-2">
      {/* Left side */}
      <AuthBackground />

      {/* Right side */}
      <div className="flex flex-col items-center justify-center md:h-full">
        <div className="flex w-full flex-col items-start rounded-xl border-0 border-solid px-5 sm:w-[450px] md:border-2 md:p-10">
          <div className="my-5 text-start text-3xl font-semibold md:text-2xl">
            <p>Sign In</p>
          </div>

          {/* Toggle Buttons */}
          <div className="flex w-full gap-1 rounded-lg bg-[#FFAE00] p-2 text-center">
            <button
              onClick={() => handleToggleMethod("otp")}
              className={`flex-1 rounded-md py-1 text-sm font-semibold transition-all duration-300 ${
                loginMethod === "otp"
                  ? "bg-white text-black shadow-md"
                  : "bg-transparent text-black"
              }`}
            >
              Sign In with OTP
            </button>
            <button
              onClick={() => handleToggleMethod("password")}
              className={`flex-1 rounded-md py-1 text-sm font-semibold transition-all duration-300 ${
                loginMethod === "password"
                  ? "bg-white text-black shadow-md"
                  : "bg-transparent text-black"
              }`}
            >
              Sign In with Password
            </button>
          </div>

          <hr className="border-1 border-graylight my-8 w-full border-solid" />

          {/* PASSWORD LOGIN */}
          {loginMethod === "password" && (
            <form className="w-full" onSubmit={handlePasswordSubmit}>
              <div className="flex w-full flex-col">
                <input
                  type="text"
                  name="identifier"
                  value={formData.identifier}
                  onChange={handleChange}
                  placeholder="Email or Mobile"
                  className="mb-4 w-full rounded-md border border-brand-primary bg-gray-100 p-2"
                  required
                />
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Password"
                    className="mb-4 w-full rounded-md border border-brand-primary bg-gray-100 p-2"
                    required
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 bottom-4 right-0 flex items-center pr-2"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FaEyeSlash className="text-brand-price-old" />
                    ) : (
                      <FaEye className="text-brand-price-old" />
                    )}
                  </button>
                </div>
              </div>
              {error && <p className="text-sm text-red-500">{error}</p>}
              {successMessage && (
                <p className="text-ForestGreen mb-4 text-sm">
                  {successMessage}
                </p>
              )}

              <Link to="/forgetpassword">
                <p className="cursor-pointer text-end text-sm text-[#FFAE00]">
                  Forget Password?
                </p>
              </Link>

              <div className="my-5 flex items-center justify-center">
                <button
                  type="submit"
                  className="w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-semibold text-black transition duration-200"
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Sign In"}
                </button>
              </div>

              <div className="flex flex-row justify-between pb-2 text-center text-xs md:text-sm">
                <p className="">
                  <span className="cursor-pointer font-semibold text-[#FFAE00]">
                    <Link to="/registration">Register</Link>
                  </span>
                </p>
                {/* <p className="">or</p>
                                <p className="">
                                    <span className="cursor-pointer font-semibold text-[#FFAE00]" onClick={() => handleToggleMethod("otp")}>
                                        Sign In
                                    </span>{" "}
                                    with OTP
                                </p> */}
              </div>
            </form>
          )}

          {/* OTP LOGIN - STEP 1: Request OTP */}
          {loginMethod === "otp" && step === "request" && (
            <form className="w-full" onSubmit={handleRequestSubmit}>
              <div className="flex w-full flex-col">
                <input
                  type="text"
                  name="identifier"
                  value={formData.identifier}
                  onChange={(e) => setFormData({...formData, identifier: e.target.value})}
                  placeholder="Enter your email or mobile number"
                  className="mb-4 w-full rounded-md border border-brand-primary bg-gray-100 p-2"
                  required
                />
              </div>
              {error && <p className="text-sm text-red-500">{error}</p>}
              {successMessage && (
                <p className="text-ForestGreen mb-4 text-sm">
                  {successMessage}
                </p>
              )}
              <div className="my-5 flex items-center justify-center">
                <button
                  type="submit"
                  className="w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-semibold text-black transition duration-200"
                  disabled={isLoading}
                >
                  {isLoading ? "Sending OTP..." : "Send OTP"}
                </button>
              </div>
              <div className="flex flex-row justify-between text-center text-xs md:text-sm">
                {/* <p className="">
                                    <span className="cursor-pointer font-semibold text-[#FFAE00]" onClick={() => handleToggleMethod("password")}>
                                        Sign In
                                    </span>{" "}
                                    with password
                                </p> */}

                {/* <p className="">or</p> */}
                <p className="">
                  <span className="cursor-pointer font-semibold text-[#FFAE00]">
                    <Link to="/registration">Register</Link>
                  </span>
                </p>
              </div>
            </form>
          )}

          {/* OTP LOGIN - STEP 2: Verify OTP */}
          {loginMethod === "otp" && step === "verify" && (
            <form className="w-full" onSubmit={handleVerifySubmit}>
              <div className="mb-4 flex w-full flex-col">
                {/* OTP input boxes container with paste support */}
                <div className="flex justify-between" onPaste={handleOtpPaste}>
                  {otpDigits.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      ref={(el) => (otpRefs.current[index] = el)}
                      className="mx-1 mb-4 h-9 w-9 rounded-md border border-brand-primary bg-gray-100 p-2 text-center text-xl md:h-12 md:w-12"
                      required
                    />
                  ))}
                </div>
              </div>
              {error && <p className="text-sm text-red-500">{error}</p>}
              {successMessage && (
                <div className="flex justify-between ">
                  <p className="text-ForestGreen mb-4 text-sm">
                    {successMessage}
                  </p>
                  <p className=" text-sm text-gray-500">
                    OTP expires in:{" "}
                    <span className="font-semibold text-red-500">
                      {String(Math.floor(timeLeft / 60)).padStart(2, "0")}:
                      {String(timeLeft % 60).padStart(2, "0")}
                    </span>
                  </p>
                </div>
              )}
              <div className="my-5 flex items-center justify-center">
                <button
                  type="submit"
                  className="w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-semibold text-black transition duration-200"
                  disabled={isLoading}
                >
                  {isLoading ? "Verifying OTP..." : "Verify OTP"}
                </button>
              </div>
              <p className="text-center text-sm">
                Didn't receive an OTP?{" "}
                <span
                  className="cursor-pointer font-semibold text-[#FFAE00]"
                  onClick={() => {
                    // Allow the user to re-send the OTP by going back to the request step.
                    setStep("request");
                    setOtpDigits(Array(6).fill(""));
                    setSuccessMessage(null);
                    setError(null);
                  }}
                >
                  Resend OTP
                </span>
              </p>
            </form>
          )}

          {/* OTP LOGIN - STEP 3: Enter Name */}
          {loginMethod === "otp" && step === "name" && (
            <form className="w-full" onSubmit={handleNameSubmit}>
              <div className="mb-4 flex w-full flex-col">
                <input
                  type="text"
                  name="first_name"
                  value={first_name}
                  onChange={(e) => setFirst_name(e.target.value)}
                  placeholder="Enter your name"
                  className="mb-4 w-full rounded-md border border-brand-primary bg-gray-100 p-2"
                  required
                />
              </div>
              {error && <p className="text-sm text-red-500">{error}</p>}
              {successMessage && (
                <p className="text-ForestGreen mb-4 text-sm">
                  {successMessage}
                </p>
              )}
              <div className="my-5 flex items-center justify-center">
                <button
                  type="submit"
                  className="w-full rounded-xl bg-[#FFAE00] px-6 py-2 font-semibold text-black transition duration-200"
                  disabled={isLoading}
                >
                  {isLoading ? "Registering..." : "Submit"}
                </button>
              </div>
            </form>
          )}
          {/* Footer Logo */}
          <div className="my-5 flex w-full items-center justify-center">
            <img src={img} alt="Bricks n Mix" className="h-12" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginOTP;
